import React from "react";

const Footer = () => {
	return (
		<footer className="footer">
			<p>
				<span className="footer-brand">Airport Taxi Transfers Varna Ltd.</span>
				Airport Taxi Transfers Varna is a trademark of Airport Taxi Transfers
				Varna Ltd. All rights reserved.
			</p>
		</footer>
	);
};

export default Footer;
